export default "__VITE_PUBLIC_ASSET__9247fb00__"